import { asset } from "./assets";

interface DonateContent {
  title: string;
  thanks: string;
  bank: {
    name: string;
    account: string;
    number: string;
    logo: string;
  };
  paynow: {
    uen: string;
    qr: string;
  };
  /** Organiser input; the UI hides the PayPal card when this is null. */
  paypalUrl: string | null;
}

export const DONATE: DonateContent = {
  title: "Donate",
  thanks: "Thank You for your willingness to support",
  bank: {
    name: "DBS",
    account: "VIHANGAM YOGA SINGAPORE LTD.",
    number: "072-491526-8",
    logo: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/1104-1104-916-1100-88-0/d5f8154a88d6416e8ff83d93507d893b.jpg?v=250703010154",
    ),
  },
  paynow: {
    uen: "201811963G",
    qr: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/1064-1256-1064-1252-0-0/527c407a23a449aab5cdf572deb10aad.jpg?v=250703010154",
    ),
  },
  paypalUrl: null,
};
